<script setup lang="ts">

</script>

<template>
  <div style="z-index: 1500 !important;width: 100%;height: 100vh;position: fixed;top: 0;right: 0;">
    <div class="uk-overlay-default uk-position-cover"></div>
    <div class="uk-position-center">
      <span uk-spinner="ratio: 5"></span>
      <p class="uk-text-bold uk-text-large">
        Un instant svp...
      </p>
    </div>
  </div>

</template>

<style scoped>

</style>